import SetPassword from './SetPassword';
export default SetPassword;
